<template>
    <draggable group="deliverableBatch" ghost-class="ghost" handle=".dragFixed" v-model='videoListModel'>
      <VideoQueueRow v-for="video in videoList" :video="video" :key="video.id"/>
    </draggable>
</template>

<script>
import draggable from 'vuedraggable'
import VideoQueueRow from '../components/VideoQueueRow.vue'

export default {
  name: 'VideoQueueGroup',
  props: {
    videoList: Array,
    batchRef: Object
  },
  components: {
    draggable,
    VideoQueueRow
  },
  computed: {
    videoListModel: {
      get() {
        return this.videoList
      },
      set(videoArray) {
        this.$store.dispatch('updateBatchMembership',[this.batchRef,videoArray])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .videoGroup {
    margin-top: 15px;
    margin-left: 15px;
  }
</style>
